import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import * as Logos from '../ui/Logos';
import { ArrowRight, MissionLogo, PlayMovie, PlayMovieOver } from '../ui/Vectors';

import '../css/screens/PerspectiveInterviewPage.scss';
import ContentBuilder from '../core/ContentBuilder';
import YoutubeLightbox from '../ui/YoutubeLightbox';
import { HistoryEvent } from '../router/History';
import RouteBuilder from '../router/RouteBuilder';
import Content from '../core/Content';
import Link from '../css/ui/Link';



export default class PerspectiveInterviewPage extends Page {

	lightbox:YoutubeLightbox;
	cover;
	componentDidMount()
	{
		if(this.props?.content?.youtube?.src && this.props.content.youtube.src.length > 0)
		{
			this.cover.addEventListener('click', this._playClick);
		}
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
	}

	componentWillUnmount()
	{
		if(this.props?.content?.youtube?.src && this.props.content.youtube.src.length > 0)
		{
			this.cover.removeEventListener('click', this._playClick);
		}
		this.history.off(HistoryEvent.CHANGE, this._historyChange);
	}

	private _playClick = () =>
	{
		if(this.lightbox) this.lightbox.show();
	}

	private _historyChange = () =>
	{
		if(this.lightbox) this.lightbox.hide();
	}

	build_profile(data)
	{
		if(!data || !data.items || data.items.length == 0) return null;
		return (
			<section className='profile'>
				<Grid cols={3} skip={1} className="padding" breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="title">{data.title}</div>
				</Grid>
				{
					data.items.map((e, i) => {
						return (
							<ProfileItem data={e} key={i}></ProfileItem>
						)
					})
				}
			</section>
		)
	}

	build_credits(data)
	{
		if(!data) return null;

		return (
			<div className="credits">
				<Grid cols={2} skip={1} breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="title padding">{data.title}</div>
					<div className="text padding">{data.text}</div>
				</Grid>
			</div>
		)
	}

	build_perspectives(data)
	{
		if(!data) return null;
		let items = [];
		data.items?.forEach((id) => {
			let d = Content.getPage(id);
			d['_id'] = id;
			if(d) items.push(d);
		});

		// "header": {
		// 	"title": "#02 interview",
		// 	"subtitle": "内山裕弥（国土交通省）\n × 杉本直也（静岡県）",
		// 	"description": "国と地方、双方で作る「デジタルツイン」\nニューノーマルの時代にデータが本当の意味でオープンになった都市データから、\n我々はいかに未来を立ち上げるのか。"
		// },
		// "tag": "Perspective #02",
		// "image": {
		// 	"src": "assets/images/interview/02/cover.jpg",
		// 	"width": 1352,
		// 	"height": 551
		// },

		return (
			<div className="perspectives">
				<Grid cols={4}>
					<div className="title text-center">{data.title}</div>
					{
						items.map((item, i)=>{
							return (
								<PerspectiveItem data={item} key={i}></PerspectiveItem>
							)
						})
					}
				</Grid>
			</div>
		)
	}

	render() {
		let coverStyle = ['cover'];
		if(this.props?.content?.youtube?.src && this.props.content.youtube.src.length > 0) coverStyle.push('hasVideo');
		return this.wrap(
			<React.Fragment>
				<div className="header">
					<div className="tag">{this.props.content.tag}</div>
					<Grid skip={2} cols={2} className="padding" breakpoints={{small: {cols:3,skip:1}}}>
						<div className="title">{this.props.content.header.title}</div>
						<div className="subtitle">{this.props.content.header.subtitle}</div>
						<div className="description">{this.props.content.header.description}</div>
					</Grid>
				</div>
				<div className={coverStyle.join(' ')} ref={r => this.cover = r}>
					<img src={this.props.content.image.src} width={this.props.content.image.width} height={this.props.content.image.height} />
					<PlayMovie className='play' style={{fill: '#FF0000'}}></PlayMovie>
					<PlayMovieOver className='playOver' style={{fill: '#FF0000'}}></PlayMovieOver>
				</div>
				<div className="content">
					<Grid cols={2} skip={1} breakpoints={{small: {cols:4, skip: 0}}}>
						{ContentBuilder.build(this.props.content.content)}
					</Grid>
				</div>
				{this.build_profile(this.props.content.profile)}
				{this.build_credits(this.props.content.credits)}
				{(this.props.content.perspectives)?this.build_perspectives(this.props.content.perspectives):null}
				{
					(this.props?.content?.youtube?.src && this.props.content.youtube.src.length > 0)?(<YoutubeLightbox ref={r => this.lightbox = r} data={this.props.content.youtube}></YoutubeLightbox>):null
				}
				
			</React.Fragment>
		);
	}
}


function ProfileItem(prop)
{
	return (
		<React.Fragment>
			<div className=" show-medium">
				<Grid cols={4} className="item">
					<Grid cols={1} className="image padding text-right">
						<img src={prop.data.image.src} width={prop.data.image.width} height={prop.data.image.height} />
					</Grid>
					<Grid cols={2} className="info padding">
						<div className="name">{prop.data.title}</div>
						<div className="description">{prop.data.description}</div>
						<div className="text">{prop.data.text}</div>
					</Grid>
				</Grid>
			</div>
			<div className="show-small">
				<Grid cols={4} className="item show-small">
					<Grid cols={1} className="image padding text-right">
						<img src={prop.data.image.src} width={prop.data.image.width} height={prop.data.image.height} />
					</Grid>
					<Grid cols={3} className="info padding">
						<div className="name">{prop.data.title}</div>
						<div className="description">{prop.data.description}</div>
					</Grid>
					<Grid cols={4}>
						<div className="text padding">{prop.data.text}</div>
					</Grid>
				</Grid>
			</div>
		</React.Fragment>
	)
}

function PerspectiveItem(prop)
{
	return (
		<div className='perspectiveItem'>
			<Grid cols={2} breakpoints={{small: {cols: 4}}} className='padding'>
				<img src={prop.data.image.src} width={prop.data.image.width} height={prop.data.image.height} className={prop.data.image.className} />
			</Grid>
			<Grid cols={2} breakpoints={{small: {cols: 4}}} className='padding'>
				<div className='title'>{prop.data.header.title}</div>
				<div className='subtitle'>{prop.data.header.subtitle}</div>
				<div className='description'>{prop.data.header.description}</div>
				<Link to={prop.data._id} className="flex flex-row">
					<div>Read</div>
					<ArrowRight className='arrow'></ArrowRight>
				</Link>
			</Grid>
		</div>
	)
}